import client from '../client';

export const readCategoryList = () => 
    client.get('/api/category');

export const readDocsList = ({ id, name, page }) =>
    client.get(`/api/docs-list/${id}`, {
        params: {
            name,
            page,
            pagesize: 13
        }
    });

export const downloadDocsList = (docsList) => 
    client.post('/api/docs-list/download', { docsList });

export const checkDuplicatedName = (nameList) => 
    client.post('/api/docs/check', { nameList });

export const uploadDocs = (formData) => 
    client.post('/api/docs/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [(data, headers) => { // 인터셉터 우회 옵션
            return data; // 기존 Content-Type 유지
        }]
    });

export const createCategory = ({ name, description, currentId }) => 
    client.post('/api/category', { name, description, currentId });

export const updateCategory = ({ id, name, description }) => 
    client.put(`/api/category/${id}`, { name, description });

export const updateDocs = ({ id, name, docsType }) => 
    client.put(`/api/docs/${id}`, { name, docsType });

export const deleteDocsList = ({ idList }) =>
    client.delete('/api/docs-list', {
        data: { idList }
    });